import React, {
  useMemo,
  useCallback,
  useState,
  useEffect,
  useRef,
} from 'react';

import {
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
} from '@material-ui/core';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import * as S from './styles';

export default function ConfirmDialog(props) {
  const { onClose, selectedValue, open, handleSubmit } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      fullWidth
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      open={open}
    >
      <DialogTitle id="alert-dialog-title">
        {t('s.operacao.afericaodvec.colocarafericaodvec')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('s.operacao.afericaodvec.confirmaaafericaodvec').replace(
            '%s',
            `o Veículo ${selectedValue?.idveiculo} - Empresa ${selectedValue?.nomeempresaveiculostr}`
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleSubmit()} color="primary">
          {t('s.geral.opcoes.sim')}
        </Button>
        <Button onClick={handleClose} color="secondary">
          {t('s.geral.opcoes.nao')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {};

ConfirmDialog.defaultProps = {};
